// Playground entry point. Bundled to playground/bundle.js via `npm run
// playground`.
//
// Monaco is loaded from the vendored `./vs` AMD bundle (see index.html), which
// resolves `window.monacoReady` once the editor module is available. We wait for
// that, then mount the React app with the Monaco instance in hand.

import { createRoot } from "react-dom/client";
import type * as MonacoNS from "monaco-editor";
import { App } from "./App.js";

type Monaco = typeof MonacoNS;

declare global {
  interface Window {
    monacoReady: Promise<Monaco>;
  }
}

window.monacoReady.then((monaco) => {
  const root = createRoot(document.getElementById("root")!);
  root.render(<App monaco={monaco} />);
});
